module.exports = __webpack_public_path__ + "img/icon-welcome.16c2a037.png";